import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.287 14.107l-2.233 7.327c-.448 1.47.741 2.154 1.743.944l8.907-10.751c.643-.777.18-1.732-.824-1.732h-4.167l2.233-7.33c.448-1.469-.741-2.153-1.743-.943L5.296 12.373c-.643.777-.18 1.732.824 1.732l4.167.002z"
});

var SvgLightningFilled = function SvgLightningFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgLightningFilled;